export default __webpack_public_path__ + "static/ombrea-videoMiseEnAvant-b218df89e9d9b8bc8f5518daa0c2f0d1.mp4";